import { Injectable } from '@angular/core';
import { ApiService } from '../../../../shared/services/api/api.service';
import { Observable } from 'rxjs';
import { IPagination } from '../../../../shared/services/api/interface/pagination.interface';
import { IAnnouncement } from '../models/announcement';


@Injectable({
  providedIn: 'root',
})
export class AnnouncementService {
  constructor(private readonly apiService: ApiService) {}

  getList() {
    return this.apiService.get<any>('announcement');
  }

  getById(id: number | null): Observable<any> {
    return this.apiService.get<any>(`announcement/${id}`);
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(
      `announcement/announcement-filter-list`,
      { event: event, filter: filter }
    );
  }

  getByFilters(filters:{user?:number | null,vehicle?:number | null,point?:number | null}): Observable<any[]> {
    return this.apiService.post<any>('announcement/by-filters', filters);
  }

  create(menu: any): Observable<IAnnouncement> {
    return this.apiService.post<any>('announcement/create', menu);
  }

  update(menu: any): Observable<IAnnouncement> {
    return this.apiService.patch<any>('announcement/update', menu);
  }

  delete(id: number): Observable<any> {
    return this.apiService.delete<any>(`announcement/delete/${id}`);
  }
}
